import {
   ADD_PURCHASE_RETURN_INVOICE,
   GET_PURCHASE_RETURN_INVOICES,
   GET_PURCHASE_RETURN_INVOICES_FOR_DAYBOOK,
   GET_PURCHASE_RETURN_INVOICES_TRANSACTIONS,
   GET_PURCHASE_RETURN_INVOICE,
   UPDATE_PURCHASE_RETURN_INVOICE,
   DELETE_PURCHASE_RETURN_INVOICE,
   LAST_BILL_PURCHASE_RETURN_INVOICE,
   GET_LAST_PURCHASE_RETURN_DAYBOOK,
   SET_LOADING,
   GET_ONE_PURCHASE_RETURN,
   EMPTY_ONE_PURCHASE_RETURN,
   GET_PURCHASE_RETURN_INVOICE_WITH_PREV_AND_NEXT,
   GET_PURCHASE_RETURN_INVOICE_PREV_AND_NEXT,
} from '../types';

const initialState = {
   list: [],
   single: null,
   totalCount: 0,
   lastBill: null,
   lastDaybook: null,
   isLoading: false,
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   purchaseReturnData: null,
   prevAndNext: null,
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      case SET_LOADING:
         return {
            ...state,
            isLoading: payload,
         };
      case EMPTY_ONE_PURCHASE_RETURN:
         return {
            ...state,
            single: payload,
         };
      case GET_PURCHASE_RETURN_INVOICES:
         return {
            ...state,
            list: payload?.data,
            totalCount: totalCount,
            isLoading: false,
            pagination: action.payload.pagination,
         };

      case GET_PURCHASE_RETURN_INVOICES_FOR_DAYBOOK:
         return {
            ...state,
            listfordaybook: payload?.data,
            totalCountfordaybook: totalCount,
            isLoadingfordaybook: false,
            paginationfordaybook: action.payload.pagination,
         }

      case GET_PURCHASE_RETURN_INVOICE:
         return {
            ...state,
            single: payload || initialState.single,
            isLoading: false,
         };

      case GET_PURCHASE_RETURN_INVOICES_TRANSACTIONS:
         return {
            ...state,
            data: payload.data || initialState.single,
            isLoading: false,
         };

      case UPDATE_PURCHASE_RETURN_INVOICE:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
            isLoading: false,
         };

      case ADD_PURCHASE_RETURN_INVOICE:
         return {
            ...state,
            list: [payload, ...state.list],
            totalCount: state.totalCount + 1,
            isLoading: false,
         };

      case DELETE_PURCHASE_RETURN_INVOICE:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
            totalCount: state.totalCount - 1,
            isLoading: false,
         };

      case LAST_BILL_PURCHASE_RETURN_INVOICE:
         return {
            ...state,
            lastBill: payload,
         };

      case GET_LAST_PURCHASE_RETURN_DAYBOOK:
         return {
            ...state,
            lastDaybook: payload,
         };

      case GET_ONE_PURCHASE_RETURN:
         return { ...state, single: payload };

      case GET_PURCHASE_RETURN_INVOICE_WITH_PREV_AND_NEXT:
         return {
            ...state,
            purchaseReturnData: { data: payload.data, pagination: payload.pagination, totalCount: payload.totalCount },
         };

      case GET_PURCHASE_RETURN_INVOICE_PREV_AND_NEXT:
         return {
            ...state,
            prevAndNext: payload,
         };

      default:
         return state;
   }
};

export default reducer;
